<template>
  <el-card class="mat12">
    <el-row class="file_box clearfix" v-if="dataDesc.pic.length>0">
      <div class="left file_name">图片：</div>
      <ul class="left file_list file_img_list">
        <li class="file_img_item" v-for="(item,index) in dataDesc.pic" :key="index + 'pic'">
            <el-image
              style="width: 100px; height: 100px"
              class="image__preview"
              :src="item.url"
              :preview-src-list="getSrcList(index)">
            </el-image>
          <!-- <div @click="handleOpenFile(item.url)">
            <i class="el-icon-document"></i>
            <span>{{item.name}}</span>
          </div> -->
        </li>
      </ul>
    </el-row>
    <el-row class="file_box clearfix mat20" v-if="dataDesc.doc.length>0">
      <div class="left file_name">附件：</div>
      <ul class="left file_list">
        <li class="file_item" v-for="(item,index) in dataDesc.doc" :key="index + 'doc'">
          <div @click="handleOpenFile(item.url)">
            <i class="el-icon-document"></i>
            <span>{{item.name}}</span>
          </div>
        </li>
      </ul>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: 'CardProcessImg',
  props: {
    dataDesc: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      srcList: []
    }
  },
  created () {
    this.srcList = this.dataDesc.pic.map(item => {
      return item.url
    })
  },
  methods: {
    handleOpenFile (url) {
      window.open(url)
    },
    getSrcList (index) {
      return this.srcList.slice(index).concat(this.srcList.slice(0, index))
    }
  }
}
</script>

<style lang="scss" scoped>
.file_box {
  display: flex;
  color: #333;
  font-size: 14px;
  .file_name {
    font-weight: bold;
    line-height: 42px;
    min-width: 60px;
  }
  .file_list {
    width: 377px;
  }
  .file_item {

    line-height: 42px;
    height: 42px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
    i {
      margin-right: 7px;
      color: #909399;
    }
  }
  .file_img_item{
    margin-right: 18px;
    display: inline-block;
  }
  .file_img_list{
    width: auto;
  }
}

</style>

<style lang="scss">
.image__preview img{
  object-fit: cover;
}
</style>
